import React from 'react';
import { BadgeDollarSign, CalendarDays, Package } from 'lucide-react';
import FeatureCard from './FeatureCard';

const Features = () => {
  const features = [
    {
      icon: BadgeDollarSign,
      title: "Gestión de Ventas",
      description: "Controle su pipeline de ventas, gestione clientes y cierre tratos más rápido con nuestras herramientas intuitivas de seguimiento y análisis."
    },
    {
      icon: CalendarDays,
      title: "Calendario Integrado",
      description: "Organice reuniones, tareas y eventos importantes. Sincronización en tiempo real para todo su equipo, asegurando que nadie pierda una cita."
    },
    {
      icon: Package,
      title: "Gestión de Inventario",
      description: "Digitalice y organice los productos de su bodega. Mantenga un registro preciso y actualizado de su stock en todo momento."
    }
  ];

  return (
    <section id="ryo" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-ribyte-600 font-semibold tracking-wider uppercase text-sm">Producto RYO</span>
          <h2 className="mt-3 text-4xl font-bold text-gray-900 sm:text-5xl">Potencie su productividad</h2>
          <p className="mt-4 text-xl text-gray-500 max-w-2xl mx-auto">
            Todas las herramientas que necesita para gestionar su negocio en una sola plataforma unificada.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {features.map((feature, index) => (
            <FeatureCard key={index} {...feature} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
